import { commonService } from '../../_services'
import { addCurrentLocationToUser } from '@/_utils/user'
// import UserModel from '@/_models/UserModel'
const userService = commonService('api/v1/user')

let remainUserTimer
let needClearSetTimeout: boolean = false
// keep for debug tracking user IndoorMap
// let isCountToMock: number = 0

export const makeUniqueProcId = (lists, prefix = '') => {
  const l: string[] = []
  for (const item of lists) {
    const id = item._id ? item._id : item
    const k = id.split('-')[0]
    l.push(k)
  }

  return prefix + l.join('.')
}

const initialState = {
  all: {
    items: [], // For User is modified (User search page)
    items_navi: [], // For dripnavi
    items_enviroment: [], // For enviroment
    items_raw: [], // For Users from db
  },
  loading: false,
}

const deepCloneInitial = JSON.parse(JSON.stringify(initialState))

export const users = {
  namespaced: true,
  state: deepCloneInitial,
  actions: {
    async getAll(context: any, params: any = {}): Promise<void> {
      context.commit('GET_ALL_REQUEST')

      return userService
        .getAll(params)
        .then(resp => {
          context.commit('GET_ALL_SUCCESS', resp.data)
        })
        .catch(errorMsg => {
          context.commit('GET_ALL_FAILURE')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        })
    },
    async getUsersRaw(context: any): Promise<void> {
      context.commit('GET_ALL_REQUEST')

      return userService
        .getAll()
        .then(resp => {
          context.commit('GET_ALL_USERS_RAW', resp.data)
        })
        .catch(errorMsg => {
          context.commit('GET_ALL_FAILURE')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        })
    },
    /*
     * Displaying users are refresh by setting, remaining (hidden under table)
     * should get a bit slower for performance purpose
     */

    clearSetTimeOut() {
      if (remainUserTimer == null) {
        return
      }

      needClearSetTimeout = true
      clearTimeout(remainUserTimer)
    },

    async getAllSplit(
      context: any,
      params: { userIds: string[]; floor: string; floor_navi?: string; floor_env?: string[] }
    ): Promise<void> {
      if (needClearSetTimeout) {
        needClearSetTimeout = false
        return
      }

      await context.dispatch('getAllSplitUserByIds', { floor: params.floor, userIds: params.userIds })

      // Fetch dripnavi data by floor
      if (params.floor_navi) {
        await context.dispatch('getAllFloorEntityData', { floor: params.floor_navi, entity: 'navi' })
      }

      if (params.floor_env && params.floor_env.length) {
        await context.dispatch('getAllFloorEntityData', { floor: params.floor_env, entity: 'enviroment' })
      }

      const remainingUserIds: string[] = []
      for (const item of context.state.all.items) {
        if (params.userIds.indexOf(item._id) === -1) {
          remainingUserIds.push(item._id)
        }
      }

      remainUserTimer = setTimeout(() => {
        // make sure not have any timeout is process
        if (needClearSetTimeout) {
          return
        }

        context.dispatch('getAllSplitUserByIds', { floor: params.floor, userIds: remainingUserIds, isRemain: true })
      }, 10000)
    },
    async getAllSplitUserByIds(
      context: any,
      params: { userIds: string[]; floor: string; isRemain?: boolean }
    ): Promise<void> {
      if ((params.isRemain && remainUserTimer) || needClearSetTimeout) {
        clearTimeout(remainUserTimer)
      }

      // Stop refresh if user not active browser tab
      if (document.hidden) {
        return
      }

      let index = 0
      let userIds: string[] = []
      const usersListIds = params.userIds
      if (!usersListIds || !usersListIds.length) {
        for (const item of context.state.all.items) {
          usersListIds.push(item._id)
        }
      }

      if (!usersListIds) {
        return
      }

      const length = usersListIds.length
      for (const userId of usersListIds) {
        index++
        userIds.push(userId)
        if (index === 10 || userId === usersListIds[length - 1]) {
          await context.dispatch('getAllByIds', { floor: params.floor, userIds })
          index = 0
          userIds = []
        }
      }
    },
    async getAllFloorEntityData(context: any, options: any = {}): Promise<void> {
      const processKey = makeUniqueProcId(options.floor, options.entity)
      if ((window as any)[processKey]) {
        return Promise.resolve()
      }

      // Stop refresh if user not active browser tab
      if (document.hidden) {
        return
      }

      const params = {
          floor: options.floor,
          entity: options.entity,
        }

        // Make a cache processing
      ;(window as any)[processKey] = true

      const commitEnityFuncPath =
        options.entity === 'navi' ? 'GET_NAVI_REQUEST_SUCCESS' : 'GET_ENVIRONMENT_REQUEST_SUCCESS'

      commonService('api/v1/user/navi')
        .getAll(params)
        .then(resp => {
          context.commit(commitEnityFuncPath, resp.data)
          return Promise.resolve(resp.data)
        })
        .catch(errorMsg => {
          context.commit('REQUEST_ERROR')
          return Promise.reject(errorMsg)
        })
        .finally(() => {
          // Remove cache processing
          delete (window as any)[processKey]
        })
    },
    async getAllByIds(context: any, options: any = {}): Promise<void> {
      const processKey = makeUniqueProcId(options.userIds)
      if ((window as any)[processKey]) {
        return Promise.resolve()
      }

      const params = {
          floor: options.floor,
          user_ids: options.userIds.join(','),
        }

        // Make a cache processing
      ;(window as any)[processKey] = true

      await userService
        .getAll(params)
        .then(resp => {
          /*
           * Do not delete. Keep for debug user feature
           */

          // isCountToMock++
          // resp.data.map((user: UserModel) => {
          //   // if (user.name === 'akira') {
          //   //   user.loc_alert = {
          //   //     alerted_at: '2020-12-13 00:34:49+09:00',
          //   //     message_code: 2
          //   //   }
          //   //   user.measureded_at = '2020-12-13 16:34:50+09:00'
          //   // }
          //   if (user.san_id === '106aa' || user.san_id === '8000000000000026') {
          //     // user.beacon_alert = {
          //     //   alerted_at: new Date(),
          //     //   message_code: 1
          //     // }

          //     // user.lat = 0
          //     // user.lon = 0

          //     user.lat = 10.8018919 + isCountToMock / 10
          //     user.lon = 106.658483 + isCountToMock / 10
          //     user.is_outside = true

          //     // beacon not registered
          //     // user.nearest_beacon_id = 'ed5195fc-b6b7-11eb-a83f-0242ac110003'

          //     if ((isCountToMock > 4 && isCountToMock < 12) || (isCountToMock > 16 && isCountToMock <= 24)) {
          //       // beacon in LLV
          //       user.nearest_beacon_id = '5bc486ec-e6f7-11eb-9dd1-0242ac110003'
          //       user.current_floor_id = '3c410962-e6f7-11eb-aa6b-0242ac110003'
          //       // user.lat = 0
          //       // user.lon = 0
          //       user.is_outside = false
          //     }

          //     user.measureded_at = new Date()
          //   }
          // })

          const beaconsStore = context.rootState.beacons.all.items
          const cardsStore = context.rootState.cards.all.items

          context.commit('GET_SPLIT_REQUEST_SUCCESS', { datas: resp.data, beacons: beaconsStore, cards: cardsStore })
          return Promise.resolve(resp.data)
        })
        .catch(errorMsg => {
          context.commit('REQUEST_ERROR')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
          return Promise.reject(errorMsg)
        })
        .finally(() => {
          // Remove cache processing
          delete (window as any)[processKey]
        })
    },
    async getOne(context: any, id: string): Promise<void> {
      context.commit('GET_REQUEST')

      return userService
        .getOne(id)
        .then(resp => {
          context.commit('GET_REQUEST_SUCCESS', resp.data)
          return Promise.resolve(resp.data)
        })
        .catch(errorMsg => {
          context.commit('REQUEST_ERROR')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
          return Promise.reject(errorMsg)
        })
    },
    async addOne(context: any, data: any): Promise<void> {
      context.commit('ADD_REQUEST')

      return userService
        .addOne(data)
        .then(resp => {
          // Fetch just added data
          userService.getOne(resp.data._id).then(singleData => {
            context.commit('ADD_ITEM_SUCCESS', singleData.data)
          })
          return Promise.resolve(resp.data)
        })
        .catch(errorMsg => {
          context.commit('REQUEST_ERROR')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
          return Promise.reject(errorMsg)
        })
    },
    async updateOne(context: any, data: any): Promise<void> {
      context.commit('UPDATE_REQUEST')

      return userService
        .updateOne(data)
        .then(resp => {
          return userService.getOne(resp.data._id).then(singleData => {
            context.commit('UPDATE_ITEM_SUCCESS', singleData.data)
            return Promise.resolve(singleData.data)
          })
        })
        .catch(errorMsg => {
          context.commit('REQUEST_ERROR')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
          return Promise.reject(errorMsg)
        })
    },
    async deleteOne(context: any, data: any): Promise<void> {
      context.commit('DELETE_REQUEST')
      return userService
        .deleteOne(data._id)
        .then(resp => {
          context.commit('DELETE_ITEM_SUCCESS', data)
          return Promise.resolve(resp.data)
        })
        .catch(errorMsg => {
          context.commit('REQUEST_ERROR')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
          return Promise.reject(errorMsg)
        })
    },
    async hasRefs(context: any, data: any): Promise<void> {
      context.commit('GET_REQUEST')
      return userService
        .hasRefs(data._id)
        .then(resp => {
          context.commit('GET_REQUEST_SUCCESS', resp.data)
          return Promise.resolve(resp.data)
        })
        .catch(errorMsg => {
          context.commit('REQUEST_ERROR')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        })
    },
    async importCSV(context: any, file: File): Promise<void> {
      context.commit('CSV_UPLOADING')
      return userService
        .importCSV(file)
        .then(resp => {
          context.commit('CSV_UPLOAD_FINISHED')
          // Reload list data
          context.dispatch('getAll')
          return Promise.resolve(resp.data)
        })
        .catch(errorMsg => {
          context.commit('REQUEST_ERROR')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
          return Promise.reject(errorMsg)
        })
    },
    resetState(context: any) {
      context.commit('RESET_STATE')
    },
  },
  mutations: {
    GET_ALL_REQUEST(state: any) {
      state.loading = true
    },
    GET_ALL_SUCCESS(state: any, allItems: any[]) {
      state.all.items = allItems.map(item => item)
      state.loading = false
    },
    GET_ALL_USERS_RAW(state: any, allItems: any[]) {
      state.all.items_raw = allItems.map(item => item)
      state.loading = false
    },
    GET_ALL_FAILURE(state: any, error: string) {
      state.all = { items: [], items_raw: [] }
      state.messages = { error: [error] }
      state.loading = false
    },
    GET_REQUEST(state: any) {
      state.loading = true
    },
    GET_REQUEST_SUCCESS(state: any) {
      state.loading = false
    },
    GET_NAVI_REQUEST_SUCCESS(state: any, resp) {
      state.all.items_navi = resp
    },
    GET_ENVIRONMENT_REQUEST_SUCCESS(state: any, resp) {
      state.all.items_enviroment = resp
    },
    GET_SPLIT_REQUEST_SUCCESS(state: any, { datas, beacons, cards }) {
      state.loading = false
      state.all.items = state.all.items.map(tmp => {
        const newUpdatedUser = datas.find(data => data && data._id === tmp._id)
        if (newUpdatedUser) {
          return addCurrentLocationToUser(newUpdatedUser, beacons, cards)
        }

        return tmp
      })
    },
    ADD_REQUEST(state: any) {
      state.loading = true
    },
    UPDATE_REQUEST(state: any) {
      state.loading = true
    },
    DELETE_REQUEST(state: any) {
      state.loading = true
    },
    ADD_ITEM_SUCCESS(state: any, item: any) {
      state.all.items_raw.push(item)
      state.loading = false
    },
    UPDATE_ITEM_SUCCESS(state: any, item: any) {
      state.all.items_raw = state.all.items_raw.map(tmp => {
        return tmp._id === item._id ? item : tmp
      })

      state.loading = false
    },
    CSV_UPLOADING(state: any) {
      state.loading = true
    },
    CSV_UPLOAD_FINISHED(state: any, item: any) {
      state.loading = false
    },
    DELETE_ITEM_SUCCESS(state: any, item: any) {
      const index = state.all.items_raw.indexOf(item)
      state.all.items_raw.splice(index, 1)
      state.loading = false
    },
    RESET_STATE(state: any) {
      const init = JSON.parse(JSON.stringify(initialState))
      Object.keys(init).forEach(key => {
        state[key] = init[key]
      })
    },
    REQUEST_ERROR(state: any, error: any) {
      state.messages = { error: [error] }
      state.loading = false
    },
  },
  getters: {
    canEdit: state => () => {
      return userService.canEdit()
    },
    canDelete: state => () => {
      return userService.canDelete()
    },
  },
}
